import { useState, useEffect } from "react";
import { X, Lightning, PaperPlaneTilt } from "@phosphor-icons/react";
import api, { formatApiErrorDetail } from "@/lib/api";
import { toast } from "sonner";

export default function NewsletterPopup() {
  const [open, setOpen] = useState(false);
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    if (localStorage.getItem("eg_popup_seen")) return;
    const t = setTimeout(() => setOpen(true), 9000);
    return () => clearTimeout(t);
  }, []);

  const close = () => { setOpen(false); localStorage.setItem("eg_popup_seen", "1"); };

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await api.post("/newsletter", { email });
      toast.success("Welcome! Your 10% code is on its way.");
      close();
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail));
    } finally { setBusy(false); }
  };

  if (!open) return null;

  return (
    <div className="fixed inset-0 z-[80] grid place-items-center p-4" data-testid="newsletter-popup">
      <div className="absolute inset-0 bg-black/60 backdrop-blur-sm" onClick={close} />
      <div className="relative w-full max-w-lg overflow-hidden rounded-3xl border border-border bg-card shadow-soft-lg">
        <div className="grid sm:grid-cols-2">
          <div className="hidden sm:block relative">
            <img src="https://images.unsplash.com/photo-1571068316344-75bc76f77890?crop=entropy&cs=srgb&fm=jpg&q=85&w=600" alt="Electric bike offer" className="h-full w-full object-cover" />
            <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent" />
          </div>
          <div className="p-7">
            <button onClick={close} className="absolute right-4 top-4 grid h-9 w-9 place-items-center rounded-full hover:bg-muted" aria-label="Close popup" data-testid="popup-close"><X size={20} /></button>
            <span className="inline-flex items-center gap-1.5 overline"><Lightning size={14} weight="fill" /> Limited Offer</span>
            <h3 className="mt-3 text-2xl font-black tracking-tight leading-tight">Get 10% off your first ebike</h3>
            <p className="mt-2 text-sm text-muted-foreground">Join our newsletter and unlock an exclusive welcome discount plus early access to new arrivals.</p>
            <form onSubmit={submit} className="mt-5 space-y-3">
              <input
                type="email" required value={email} onChange={(e) => setEmail(e.target.value)}
                placeholder="Enter your email"
                className="w-full rounded-full border border-border bg-background px-5 py-3 text-sm outline-none focus:border-primary"
                data-testid="popup-email-input"
              />
              <button disabled={busy} className="btn-primary w-full" data-testid="popup-submit">
                {busy ? "Subscribing…" : <>Claim 10% Off <PaperPlaneTilt size={16} /></>}
              </button>
            </form>
            <button onClick={close} className="mt-3 text-xs text-muted-foreground hover:underline">No thanks, I'll pay full price</button>
          </div>
        </div>
      </div>
    </div>
  );
}
